import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainComponent } from './main/main.component';
import { SearchComponent } from './search-external-api/search/search.component';
import { SessionProperlyStartedGuard } from './route-guards/session-properly-started.guard';
import { MakeOerComponent } from './make-oer/make-oer.component';
import { ReplaceByImageFromMachineComponent } from './replace-by-image-from-machine/replace-by-image-from-machine.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { ReadyForFeedbackGuard } from './route-guards/ready-for-feedback.guard';
import { ExcludeFromOverallLicenseComponent } from './exclude-from-overall-license/exclude-from-overall-license.component';
import { AdminAreaComponent } from './admin-area/admin-area.component';
import { UsersComponent } from './admin-area/users/users.component';
import { TasksComponent } from './admin-area/tasks/tasks.component';
import { FeedbacksComponent } from './admin-area/feedbacks/feedbacks.component';
import { ModuleSelectorComponent } from './module-selector/module-selector.component';
import { TextModuleComponent } from './text-module/text-module.component';
import { VideoModuleComponent } from './video-module/video-module.component';

const routes: Routes = [
  { path: '', component: ModuleSelectorComponent },
  { path: 'text', component: TextModuleComponent },
  { path: 'video', component: VideoModuleComponent },
  { path: 'image', component: MainComponent },
  { path: 'search-api', component: SearchComponent, canActivate: [SessionProperlyStartedGuard]},
  { path: 'publish-as-oer', component: MakeOerComponent, canActivate: [SessionProperlyStartedGuard]},
  { path: 'replace-by-from-machine', component: ReplaceByImageFromMachineComponent, canActivate: [SessionProperlyStartedGuard]},
  { path: 'exclude', component: ExcludeFromOverallLicenseComponent, canActivate: [SessionProperlyStartedGuard]},
  { path: 'feedback', component: FeedbackComponent, canActivate: [ReadyForFeedbackGuard]},
  { path: 'admin', component: AdminAreaComponent,
    children: [
      { path: 'users', component: UsersComponent },
      { path: 'tasks', component: TasksComponent },
      { path: 'feedbacks', component: FeedbacksComponent },
      { path: '', redirectTo: 'users', pathMatch: 'full' },
    ]
  },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
